<app-breadcrumb [master]="'Administracja'" [parentName]="'Chronie'"  [name]="'Status workerów'"></app-breadcrumb>
<div class="chronie-job-list-container">

  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="row-list-filters">
    <mat-form-field class="chronie-job-list-filter-long">
      <mat-label>Policy Id</mat-label>
      <input matInput placeholder="Policy Id"
             [(ngModel)]="initialFilters.policyUuid" name="policyUuid">
    </mat-form-field>
    <mat-form-field class="chronie-job-list-filter-long">
      <mat-label>Order Id</mat-label>
      <input matInput placeholder="Order Id"
             [(ngModel)]="initialFilters.orderUuid" name="orderUuid">
    </mat-form-field>

  </form>
  <div class="chronie-job-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary">
      <mat-icon>search</mat-icon>
      <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Resetuj filtry</span></button>
  </div>
  <table mat-table [dataSource]="jobList" matSort (matSortChange)="sortChanged($event)">
    <ng-container matColumnDef="jobUuid">
      <th mat-header-cell *matHeaderCellDef> Job uuid</th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link chronie-job-font" (click)="copyMessage(element.uuid )">{{ element.uuid }}</a>
      </td>
    </ng-container>
<!--    <ng-container matColumnDef="orderUuid">-->
<!--      <th mat-header-cell *matHeaderCellDef > order uuid</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <a class="default-link chronie-job-font">{{ element.orderUuid }}</a>-->
<!--      </td>-->
<!--    </ng-container>-->
<!--    <ng-container matColumnDef="calledBy">-->
<!--      <th mat-header-cell *matHeaderCellDef > calledBy</th>-->
<!--      <td mat-cell *matCellDef="let element">-->
<!--        <span class="chronie-job-font">{{ element.calledBy }}</span>-->
<!--      </td>-->
<!--    </ng-container>-->

    <ng-container matColumnDef="parameters">
      <th mat-header-cell *matHeaderCellDef> Parametry</th>
      <td mat-cell *matCellDef="let element">
        <div fxLayout="column" fxLayoutGap="2px">
          <div *ngFor="let p of toEntries(element.parameters)">
            <strong>{{ p.key }}: </strong> <a class="default-link chronie-job-font" (click)="copyMessage(p.value)">{{ p.value }}</a>
          </div>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="requestedAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="requestedAt">Data rozpoczęcia</th>
      <td mat-cell *matCellDef="let element">
        <span class="chronie-job-font"> {{ element.requestedAt | date:'y-MM-dd' }}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="runTries">
      <th mat-header-cell *matHeaderCellDef> Próby </th>
      <td mat-cell *matCellDef="let element">
     <span class="chronie-job-font"> {{ element.runTries}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="progress">
      <th mat-header-cell *matHeaderCellDef> progress | code | success</th>
      <td mat-cell *matCellDef="let element">
      <span class="chronie-job-font">{{ element.progress}} | {{ element.exitCode}} | {{ element.success}}</span>
      </td>
    </ng-container>
    <ng-container matColumnDef="output">
      <th mat-header-cell *matHeaderCellDef> Wyjście </th>
      <td mat-cell *matCellDef="let element">
     <span class="chronie-job-font"> {{ element.output}}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="error">
      <th mat-header-cell *matHeaderCellDef> Error </th>
      <td mat-cell *matCellDef="let element">
     <span class="chronie-job-font"> {{ element.error}}</span>
      </td>
    </ng-container>




    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[50, 150, 200]" [length]="totalData"></mat-paginator>

</div>
